import React from 'react';
import { useSelector } from 'react-redux';
import { i18next, readOnly } from '@yola/ws-sdk';
import { designSystem } from '@yola/ws-ui';
import takeControl from '../operations/take-control';

const { ActionButton, Paragraph, Icon, HorizontalStack, Box } = designSystem;

const ReadOnlyBannerContainer = () => {
  const readOnlyStatus = useSelector(readOnly.selectors.getReadOnlyStatus);

  if (!readOnlyStatus) return null;

  return (
    <div className="ws-read-only-banner">
      <Box padding="spacing-2-xs">
        <HorizontalStack gap="spacing-xs" align="center" verticalAlign="center">
          <HorizontalStack gap="spacing-2-xs" align="center" verticalAlign="center">
            <Paragraph appearance="white">
              <strong>{i18next.t('Read-only Mode')}</strong>
            </Paragraph>
            <Icon glyph="eye" type="white" insideText />
            <Paragraph appearance="white">
              {i18next.t(
                'Active editing session is open in another tab. Continue working there or take control here.'
              )}
            </Paragraph>
          </HorizontalStack>
          <ActionButton label={i18next.t('Take control')} onClick={takeControl} size="small" />
        </HorizontalStack>
      </Box>
    </div>
  );
};

export default ReadOnlyBannerContainer;
